import { InsurancePositionKind } from "@medbillai/generated-graphql-types";

export const DEDUCTIBLES = {
  individual: InsurancePositionKind.DEDUCTIBLE_INDIVIDUAL,
  family: InsurancePositionKind.DEDUCTIBLE_FAMILY,
};
export const OUT_OF_POCKET = {
  individual: InsurancePositionKind.OOP_INDIVIDUAL,
  family: InsurancePositionKind.OOP_FAMILY,
};

/**
 * The plan's own figures. Figures for a carved-out service say nothing about
 * this plan's totals.
 */
export const ownPositions = <P extends { service: string }>(membership: {
  coverageType: string;
  positions: P[];
}): P[] =>
  membership.positions.filter(p => p.service === membership.coverageType);
